
.root {
    width: 100%;
    height: 100%;
    touch-action: pan-x pan-y;
}

/* Fix scrolling the page on mobile when touching a map https://github.com/openlayers/openlayers/issues/6767#issuecomment-378929233 */

:global .ol-viewport {
    touch-action: auto !important;
}

/* Map Attribution; customize OpenLayers defaults to be printing friendly */

.root :global .map-attribution {
    text-align: right;
    bottom: 0;
    right: 0;
    font-size: 12px;
    padding: 2px;
    border-radius: 3px;
    background-color: rgba(255, 255, 255, 0.6) !important;
}

.printout :global .map-attribution {
    font-size: 6px;
}

.root :global .map-attribution ul {
    margin: 0;
    padding: 0;
}

.root :global .map-attribution li {
    display: inline;
    list-style: none;
    line-height: inherit;
}

.printout :global .map-attribution a {
    color: inherit !important;
    text-decoration: none !important;
}

.root :global .map-attribution button,
.root :global .map-attribution img {
    display: none !important;
}

@media print {
    .root :global .map-attribution {
        display: block !important;
    }

    .root :global .ol-control {
        display: none;
    }

    .root :global .ol-control.ol-rotate {
        display: block;
    }
}
